import React, { ReactElement } from 'react';

const CreditsIcon = (): ReactElement => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
      <g clipPath="url(#clip0_1108_3340)">
        <path
          d="M7.5 14.25C10.9518 14.25 13.75 11.4518 13.75 8C13.75 4.54822 10.9518 1.75 7.5 1.75C4.04822 1.75 1.25 4.54822 1.25 8C1.25 11.4518 4.04822 14.25 7.5 14.25Z"
          fill="#E21D4A"
          stroke="#E21D4A"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7.5 5.5V10.5" stroke="#F3FCFC" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
        <path d="M5 8H10" stroke="#F3FCFC" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1108_3340">
          <rect width="15" height="15" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CreditsIcon;
